<template>
    <section>
        <div class="relative z-0 overflow-y-auto focus:outline-none flex-1">
            <menubar v-if="authenticated" :user="authenticated"></menubar>
            <notification
                v-if="notification"
                :notification="notification"
            ></notification>
            <my-profile v-if="showMyProfile"></my-profile>
            <main>
                <proxy-voting-poll
                    v-if="proxyVoting"
                    :notification="proxyVoting"
                    @hide="proxyVoting = false"
                ></proxy-voting-poll>

                <router-view v-slot="{ Component }">
                    <transition name="fade" mode="out-in">
                        <component :is="Component"></component>
                    </transition>
                </router-view>
            </main>
        </div>
    </section>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-active {
    opacity: 0;
}
</style>
<script>
import Notification from "../components/Notification.vue";
export default {
    components: { Notification },
    mounted() {
        if (this.notification_channel) {
            Eventing.listen("show2FA", () => this.$router.push("/access"));
        }
        Eventing.listen("checkAuthStatus", () => this.checkAuth());

        Eventing.listen("notify", (notification) =>
            this.setNotification(notification),
        );

        Eventing.listen("backHome", () => this.navigateToDashboard());
        // else {
        //     this.$router.push("/login");
        // }
        this.checkAuth();

        Eventing.listen("openMyProfile", () => (this.showMyProfile = true));
    },
    created() {
        let self = this;
        if (this.notification_channel) {
            Echo.private(`users.` + this.notification_channel).notification(
                (notification) => {
                    if (notification.type.includes("NewMessage")) {
                        try {
                            if (notification.url.includes("dashboard")) {
                                return (window.location = notification.url);
                            }
                        } catch (error) {}

                        try {
                            if (notification.url.includes("backstage")) {
                                self.$router.push({
                                    name: "backstage",
                                });
                                return;
                                // return (window.location = notification.url);
                            }
                        } catch (error) {}

                        Eventing.fire("notify", {
                            title: self.t("notification.invite", "Uitnodiging"),
                            message: self.t(
                                "notification.invite.invitation",
                                ":value nodigt u uit om met uw webcam deel te nemen aan deze vergadering.<br>Onderin het scherm kunt u uw webcam starten of uw scherm delen.",
                                notification.sender,
                            ),
                            type: "success",
                            position: "center",
                        });
                        Eventing.fire("invitedForMeeting");

                        try {
                            if (notification.url.includes("logout")) {
                                return (window.location = notification.url);
                            }
                        } catch (error) {}
                        console.info(this.notification);
                    }
                    if (notification.type.includes("InvitationMeetup")) {
                        // this.incoming = notification;
                    }
                    if (notification.type.includes("InitProxyVotings")) {
                        this.proxyVoting = notification;
                    }
                },
            );
        }
    },
    props: ["notification_channel"],
    data() {
        return {
            notification: null,
            menuLoaded: false,
            authenticated: false,
            showMyProfile: false,
            proxyVoting: false,
        };
    },
    methods: {
        setNotification(notification) {
            let self = this;
            self.notification = notification;
            setTimeout(() => {
                self.notification = false;
            }, 6000);
        },
        navigateToDashboard() {
            this.checkAuth();
            // this.$router.push("/dashboard");
        },
        checkAuth() {
            axios
                .post("/auth?view=app")
                .then((response) => {
                    if (response.data.user) {
                        this.authenticated = response.data.user;
                        if (!this.authenticated.is_blocked) {
                            if (this.$route.fullPath == "/") {
                                this.$router.push("/dashboard");
                            }
                        }
                        // console.info(this.authenticated);
                    } else {
                        this.$router.push("/login");
                    }
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push("/login");
                    }
                    if (
                        error.response.status == 403 ||
                        error.response.status == 401
                    ) {
                        if (confirm("Error: " + error.response.status)) {
                            window.location = "/logoff";
                        } else {
                            window.location = "/logoff";
                        }
                    }
                });
        },
    },
};
</script>
